import { fork } from 'redux-saga/effects';
import { requestsWatcher } from './requestsSagas';
import { fieldsConfigWatcher } from './fieldsConfigSagas';
// import { filtersConfigWatcher } from './filtersSaga';

export default function* Requests() {
  yield fork(requestsWatcher);
  yield fork(fieldsConfigWatcher);
  // yield fork(filtersConfigWatcher);
}
